import React from "react";
import ReactLoading from "react-loading";
import { Section, SectionMinified } from "./styles";

const LoadingComponent = ({ minified }) => {
  const theme = localStorage.getItem("theme");
  const color = theme === "dark" ? "#fff" : "rgb(38 119 247)";

  return minified === true ? (
    <SectionMinified>
      <ReactLoading type="bars" color={color} />
    </SectionMinified>
  ) : (
    <Section>
      <ReactLoading type="bars" color={color} />
    </Section>
  );
};

export default LoadingComponent;
